export function downloadFromIframe(fileUrl: string, fileName: string): void {
  const iframe = document.createElement('iframe');
  iframe.src = fileUrl;
  iframe.name = 'Download ' + fileName;
  iframe.style.position = 'fixed';
  document.body.appendChild(iframe);
}
